import { makeStyles } from "@material-ui/core/styles";
import { MYCOLORS } from "../../mypallette";

export const useAboutStyles = makeStyles({
  cardmainLight: {
    minWidth: 275,
    background: `radial-gradient(circle at center, ${MYCOLORS.lback} 40%, ${MYCOLORS.lhighlight} 140%)`,
    //background: MYCOLORS.lhighlight,
  },
  cardmainDark: {
    minWidth: 275,
    background: `radial-gradient(circle at center, ${MYCOLORS.ddeck} -100%, ${MYCOLORS.dback} 70%)`,
  },
});
